import changePasswordTemplate from './changePassword.html';
import groupInviteTemplate from './groupInvite.html';
import userActivationTemplate from './userActivation.html';

const extrasConfig = ($stateProvider) => {
    $stateProvider
        .state('changePassword', {
            url: '/reset/change?token',
            template: changePasswordTemplate,
            controller: 'changePasswordController',
            controllerAs: 'changePassword'
        })
        .state('groupInvitation', {
        	url: '/groupInvitation?token',
            template: groupInviteTemplate,
            controller: 'groupInviteController',
            controllerAs: 'groupInvite'
        })
        .state('userActivation', {
        	url: '/user/activate?token',
            template: userActivationTemplate,
            controller: 'userActivationController',
            controllerAs: 'userActivation'
        });
};

export default extrasConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/extras/extras.config.js
 **/